import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { GIRLS_CATEGORY, S3_BUCKET_URL, WOMEN_CATEGORY } from '@/constants';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { useRoleplayRoomGirlImage } from '@/pages/Onboarding/Layouts/OwnAIRoleplayRooms/hooks/useRoleplayRoomGirlImage.ts';
import { LayoutDataType } from '@/pages/Onboarding/Layouts/OwnAIRoleplayRooms/types';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { ScreenAboutLookStyles } from './AboutLook.styles';

export const ScreenAboutLook: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'AboutLook',
      });
    }
  }, []);

  useRoleplayRoomGirlImage();

  const { wizard } = useOnboarding();
  const form = useFormContext<LayoutDataType>();
  const age = form.watch('age');

  const handleNextStep = (): void => {
    const categoriesToPin =
      age === 'experienced' ? WOMEN_CATEGORY : GIRLS_CATEGORY;

    userService.createOrUpdate({
      categories: [categoriesToPin],
      onboarding_data: {
        first_categories: categoriesToPin,
      },
    });
    wizard.nextStep();
  };

  const getBgImage = () => {
    return `${S3_BUCKET_URL}/layout-own-ai/bg-about-look.png`;
  };

  return (
    <ScreenAboutLookStyles
      background={'dark-solid'}
      bgImage={<img src={getBgImage()} alt="Chat Vibe" />}
    >
      <IonContent>
        <OwnAiTitle className="local-title">
          Wow... She's dangerously hot 🔥
        </OwnAiTitle>
      </IonContent>

      <OnboardingFooter
        onContinue={handleNextStep}
        buttonText={'Keep it going'}
      />
    </ScreenAboutLookStyles>
  );
};
